import {motion} from 'framer-motion';
import Card from "../shared/Card";
import GeneralContext from '../../context/GeneralContext';
import { useContext } from 'react';
import ButtonFunction from '../shared/ButtonFunction';
import { GiFiles } from "react-icons/gi";

function ManageRequests() {

    const { changeCurrentMenu } = useContext(GeneralContext);

    return (
      <motion.div
        key='adminManageRequests'
        initial={{opacity: 0, x: -1000}}
        animate={{opacity: 1, x: 0}}
        exit={{opacity: 0, x: -1000, transition:{duration: 0.5, delay: 0}}}
        transition={{duration: 0.5}}>
          <Card>
              <GiFiles size='50px'/>
              <h2>Gestionar Solicitudes</h2>
              <ButtonFunction
                buttonFunction={changeCurrentMenu}
                buttonArguments={'pending-requests'}
                buttonClass='adminButton'
              >
                Solicitudes Pendientes
              </ButtonFunction>
              <br />
              <br />
              <ButtonFunction 
                buttonFunction={changeCurrentMenu}
                buttonArguments={'requests-history-users'}
                buttonClass='adminButton'
              >
                Historial por Usuario
              </ButtonFunction>
              <br />
              <br />
              <ButtonFunction
              buttonFunction={changeCurrentMenu}
              buttonArguments={'requests-history-recent'}
              buttonClass='adminButton'
              >
                Historial Reciente
              </ButtonFunction>
          </Card>
        </motion.div>
    )
}

export default ManageRequests